@if (isLoading) {
    <sb-loader></sb-loader>
} @else if (!isEmailSelected) {
    <app-welcome [createdTicketsData]="createdTicketsData" (openForm)="isEmailSelected = true"> </app-welcome>
} @else {
    <div class="ticket-form">
        @if (!isTicketCreated) {
            <div class="form-header">
                <button class="btn btn-default" [disabled]="isSaving" (click)="cancel()" type="button">
                    {{ 'Cancel' | translate }}
                </button>

                @if (!isReadOnlyUser) {
                    <button
                        class="btn btn-primary"
                        [disabled]="
                            isSaving ||
                            !formModel.community ||
                            isLoadingUserAndFormData ||
                            !formCommonDataService.isMessageContentLoaded
                        "
                        (click)="processCreateTicket()">
                        {{ 'Create ticket' | translate }}
                    </button>
                }
            </div>

            <div class="form-wrapper">
                @if (isAttachmentLoadingError) {
                    <div class="alert alert-warning d-flex">
                        <sb-inline-svg
                            class="icon"
                            [url]="'/sb-tools/theme/images/Svg icons WEB/Web icons/Warning icon v1.svg'">
                        </sb-inline-svg
                        >&nbsp;
                        <span>{{
                            'Not enough permissions to forward attachments. Ask your Microsoft 365 administrator to adjust Microsoft Entra ID settings.'
                                | translate
                        }}</span>
                    </div>
                }
                @if (!outlookUserService.communities?.length) {
                    <div class="alert alert-info d-flex">
                        <sb-inline-svg
                            class="icon"
                            [url]="'/sb-tools/theme/images/Svg icons WEB/Web icons/Lockd icon.svg'">
                        </sb-inline-svg
                        >&nbsp;
                        <span>{{
                            "Sorry, you can't create tickets because there are no communities available for you."
                                | translate
                        }}</span>
                    </div>
                } @else {
                    <div class="scrolled-wrapper">
                        <div class="form-group form-element">
                            <label>{{ 'Choose inbox *' | translate }}</label>
                            <ng-select
                                name="inbox-selector"
                                bindLabel="communityName"
                                bindValue="communityName"
                                dropdownPosition="bottom"
                                class="select-control"
                                notFoundText="{{ 'No inbox found' | translate }}"
                                placeholder="{{ 'Choose inbox *' | translate }}"
                                [appendTo]="'body'"
                                [items]="outlookUserService.communities"
                                [required]="true"
                                (change)="onSelectCommunity($event)"
                                [(ngModel)]="formModel.community">
                            </ng-select>
                        </div>

                        @if (formModel.community) {
                            @if (isLoadingUserAndFormData) {
                                <sb-loader></sb-loader>
                            } @else {
                                @if (isReadOnlyUser) {
                                    <div class="alert alert-info d-flex">
                                        <sb-inline-svg
                                            class="icon"
                                            [url]="'/sb-tools/theme/images/Svg icons WEB/Web icons/Lockd icon.svg'">
                                        </sb-inline-svg
                                        >&nbsp;
                                        <span>{{
                                            'Not enough permissions to create tickets in this community' | translate
                                        }}</span>
                                    </div>
                                } @else {
                                    <form
                                        #ticketForm="ngForm"
                                        [ngClass]="{ 'form-submitted': formService.isSubmitted }"
                                        [ngForm]="ticketForm"
                                        (ngSubmit)="isSaving || isReadOnlyUser || processCreateTicket()"
                                        appCheckFormInit
                                        autocomplete="off"
                                        class="form form-fields-with-rules">
                                        @for (formField of formModel.fields; track formField) {
                                            <sb-form-field
                                                [class.highlighted]="
                                                    formField.isDependant && formField.isShowedBecauseOfRule
                                                "
                                                [formField]="formField"
                                                [formType]="formTypes.outlook"
                                                appCheckFieldRules
                                                [field]="formField"
                                                [fields]="formModel.fields">
                                            </sb-form-field>
                                        }

                                        @if ((formModel.allAttachments | filterInlineAttachments).length) {
                                            <div class="form-group form-element">
                                                <label>{{ 'Include attachments' | translate }}</label>

                                                @for (
                                                    attachment of formModel.allAttachments | filterInlineAttachments;
                                                    track attachment;
                                                    let idx = $index
                                                ) {
                                                    <div class="attachment-element">
                                                        <label
                                                            class="checkbox__label checkbox__label--size-small"
                                                            for="{{ 'ticketAttachment_' + idx }}">
                                                            <span class="attachment-name">{{ attachment.name }}</span>
                                                            <input
                                                                type="checkbox"
                                                                name="{{ 'ticketAttachment_' + idx }}"
                                                                id="{{ 'ticketAttachment_' + idx }}"
                                                                [(ngModel)]="attachment.isMarked" />
                                                            <span class="checkbox__checkmark"></span>
                                                        </label>
                                                    </div>
                                                }
                                            </div>
                                        }
                                    </form>
                                }
                            }
                        }
                    </div>
                }
            </div>
        } @else {
            <div class="p-3">
                <div class="d-flex align-items-center justify-content-between">
                    <button
                        type="button"
                        class="btn btn-icon btn-transparent btn-back"
                        [attr.aria-label]="'Close' | translate"
                        (click)="backToForm()">
                        <sb-inline-svg class="icon icon-back" [url]="'/assets/images/arrow-left.svg'"></sb-inline-svg>
                    </button>

                    <button type="button" class="btn btn-default" (click)="copyLink()">
                        {{ 'Copy ticket link to clipboard' | translate }}
                    </button>
                </div>

                <hr />

                <div class="d-flex align-items-start feedback-wrapper">
                    <sb-inline-svg class="icon icon-check" [url]="'/assets/images/Check icon.svg'"></sb-inline-svg>

                    <div class="ms-3">
                        <p class="mb-4">{{ 'The ticket was successfully created' | translate }}</p>

                        <a class="link" [href]="newTicketLink" target="_blank">{{ 'View in inbox >>' | translate }}</a>
                    </div>
                </div>
            </div>
        }
    </div>
}
